import { render, staticRenderFns } from "./edit-survey-controls.vue?vue&type=template&id=63703952&"
import script from "./edit-survey-controls.vue?vue&type=script&lang=js&"
export * from "./edit-survey-controls.vue?vue&type=script&lang=js&"
import style0 from "./edit-survey-controls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63703952')) {
      api.createRecord('63703952', component.options)
    } else {
      api.reload('63703952', component.options)
    }
    module.hot.accept("./edit-survey-controls.vue?vue&type=template&id=63703952&", function () {
      api.rerender('63703952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/edit-survey-controls.vue"
export default component.exports